export default __webpack_public_path__ + "static/media/admeet_logo-quote.eb4183fa.svg";